import meta from '@/meta'

export const defaultConfig = (language?: string) => {
  let lang = language ? {
    'Accept-Language': language
  } : {};
  return {
    headers: {
      ...lang,
      'X-CSRF-Token': meta('csrf-token'),
      'X-Forwarded-Proto': 'https'
    }
  }
}
